//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { useNav } from 'src/onboarding/hooks/nav';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { t } from '@web-solutions/module-localization';

import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/store/hooks';
import { submitCancelSubscription } from 'core/upsale/store/actions';
import { useUpsalePurchase } from 'core/upsale/hooks/use-upsale-purchase';
import { subscribe } from 'core/store/billing/actions';
import { PaymentSystem } from '@web-solutions/react-billing';
import { UPSALE_NAMES } from 'core/upsale/store/types';
import { ReactComponent as LoadingIcon } from '../../../../assets/images/loading-white.svg';
import Analytics from '@web-solutions/module-analytics';
import SuccessPayment from '../successPaymentPopup';
import FailedPayment from '../failedPaymentPopup';

const WebUpsaleFirst = () => {
  const purchase = useAppSelector((state) => state.billing.purchase);

  const [loading, setLoading] = useState(false);
  const [successPayment, setSuccessPayment] = useState(false);
  const [failedPayment, setFailedPayment] = useState(false);
  const [showCheck, setShowCheck] = useState(false);

  const { onNext, onPrev } = useNav();
  const dispatch = useDispatch();

  const { upsaleFirst } = useRemoteConfig();

  const ONETIME_RECURLY_ID = upsaleFirst.oneTimeRecurlyId;

  const SUBSCRIBE_RECURLY_ID = upsaleFirst.product.recurlyId;

  const { handleUpsalePurchase, renderPaymentProcessor } = useUpsalePurchase();

  const handleSkipTrialClick = async () => {
    const formData = {
      price_id: SUBSCRIBE_RECURLY_ID,
      email: purchase?.email,
      first_name: purchase?.first_name,
      last_name: purchase?.last_name,
      method: purchase?.method,
      paymentSystem: PaymentSystem.RECURLY,
      token_id: purchase?.token_id,
    };

    setLoading(true);

    try {
      const data = await handleUpsalePurchase({
        recurlyId: ONETIME_RECURLY_ID,
        upsaleName: UPSALE_NAMES.SKIP_TRIAL,
      });

      if (!data) {
        setFailedPayment(true);
        return;
      }

      await dispatch(submitCancelSubscription(SUBSCRIBE_RECURLY_ID));

      await dispatch(subscribe(formData));

      setSuccessPayment(true);
      Analytics.trackEvent('step', 'completed', {
        upsaleID: 'web-upsale-1',
        result: 'upsale_subscribe_success',
      });

      gtag('event', 'conversion', {
        send_to: 'AW-17149973324/WBLJCNvSyP0aEMym3_E_',
        value: upsaleFirst.rightCard.amount,
        currency: 'USD',
        transaction_id: '',
      });
    } catch (error) {
      setFailedPayment(true);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (successPayment) {
      Analytics.trackEvent('popup', 'shown', {
        type: 'payment-success',
        upsaleID: 'web-upsale-1',
      });

      document.body.style.overflow = 'hidden';

      const showCheckTimer = setTimeout(() => setShowCheck(true), 500);
      const nextTimer = setTimeout(() => onNext(), 1500);

      return () => {
        clearTimeout(showCheckTimer);
        clearTimeout(nextTimer);
        document.body.style.overflow = '';
      };
    } else if (failedPayment) {
      Analytics.trackEvent('popup', 'shown', {
        type: 'failed-payment',
        upsaleID: 'web-upsale-1',
      });
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [successPayment, failedPayment]);

  useEffect(() => {
    if (failedPayment) {
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [failedPayment]);

  const leftPrices = [
    {
      description: '',
      price: upsaleFirst.leftCard.perWeek,
    },
    {
      description: t('onboarding.upsaleFirst.billedPeriod'),
      price: upsaleFirst.leftCard.period,
    },
    {
      description: t('onboarding.upsaleFirst.billedAmount'),
      price: upsaleFirst.leftCard.amount,
    },
    {
      description: t('onboarding.upsaleFirst.billedWeeks'),
      price: upsaleFirst.leftCard.billedWeeks,
    },
    {
      description: t('onboarding.upsaleFirst.trialPeriod'),
      price: upsaleFirst.leftCard.trialPeriod,
    },
  ];

  const rightPrices = [
    {
      description: '',
      price: upsaleFirst.rightCard.perDay,
    },
    {
      description: t('onboarding.upsaleFirst.billedPeriod'),
      price: upsaleFirst.rightCard.period,
    },
    {
      description: t('onboarding.upsaleFirst.billedAmount'),
      price: upsaleFirst.rightCard.amount,
    },
    {
      description: t('onboarding.upsaleFirst.billedWeeks'),
      price: upsaleFirst.rightCard.billedWeeks,
    },
    {
      description: t('onboarding.upsaleFirst.trialPeriod'),
      price: upsaleFirst.rightCard.trialPeriod,
    },
  ];

  return (
    <>
      <main className={styles.main}>
        {renderPaymentProcessor({
          activeProduct: upsaleFirst.oneTimeId,
          subscribeRecurlyId: SUBSCRIBE_RECURLY_ID,
          isOnlyOneTimePurshaseUpsale: false,
          oneTimeRecurlyId: ONETIME_RECURLY_ID,
        })}
        <Title tag='h2'>{upsaleFirst.title}</Title>
        <div className={styles.cards}>
          <div className={styles.leftCard}>
            {leftPrices.map((item, key) => (
              <div key={key}>
                {item.description && <div className={styles.description}>{item.description}</div>}
                <div className={styles.price}>{item.price}</div>
              </div>
            ))}

            <button
              className={styles.continueBtn}
              onClick={() => {
                onNext();
                Analytics.trackEvent('step', 'completed', {
                  upsaleID: 'web-upsale-1',
                  result: 'upsale_continue-with-trial',
                });
              }}
            >
              {t('onboarding.upsaleFirst.continueWithTrial')}{' '}
            </button>
          </div>
          <div className={styles.rightCard}>
            <div className={styles.rightCardTitle}>{t('onboarding.upsaleFirst.bestValue')} </div>
            <div className={styles.rightCardBody}>
              {rightPrices.map((item, key) => (
                <div key={key}>
                  {item.description && <div className={styles.description}>{item.description}</div>}
                  <div className={styles.price}>{item.price}</div>
                </div>
              ))}
              <button
                className={styles.payNowBtn}
                onClick={handleSkipTrialClick}
                disabled={loading}
              >
                {loading ? <LoadingIcon /> : t('onboarding.upsaleFirst.payNow')}
              </button>
            </div>
          </div>
        </div>
        {successPayment && (
          <SuccessPayment onClose={() => setSuccessPayment(false)} showCheck={showCheck} />
        )}

        {failedPayment && (
          <FailedPayment
            onClose={() => setFailedPayment(false)}
            onRetry={() => handleSkipTrialClick()}
            loading={loading}
          />
        )}
      </main>
      {upsaleFirst.description.length > 0 && (
        <footer className={styles.footer}>{upsaleFirst.description}</footer>
      )}
    </>
  );
};

export default WebUpsaleFirst;
